import { FormattedMessage, defineMessages } from 'react-intl';
import type { IntlShape } from 'react-intl';

import { AutoDismissFlag } from '@atlaskit/flag';
import ErrorIcon from '@atlaskit/icon/core/status-error';
import { token } from '@atlaskit/tokens';

import { HandleDismissedType } from 'src/redux/flags/types';

const messages = defineMessages({
  createCommentErrorTitle: {
    id: 'frontbucket.branches.createCommentErrorTitle',
    description:
      'Text for the title of the create comment error message on a pull request',
    defaultMessage: 'Unable to create comment',
  },
  createCommentErrorDescriptionGeneric: {
    id: 'frontbucket.branches.createCommentErrorDescriptionGeneric',
    description:
      'Text for the body of the create comment error message for a pull request',
    defaultMessage:
      'Something went wrong. We were unable to create the comment.',
  },
});

type Props = {
  id: string;
  intl: IntlShape;
} & HandleDismissedType;

export const CreateCommentErrorFlag = ({ id, intl, ...otherProps }: Props) => (
  <AutoDismissFlag
    id={id}
    {...otherProps}
    icon={
      <ErrorIcon
        spacing="spacious"
        label="error"
        color={token('color.icon.danger')}
      />
    }
    title={<FormattedMessage {...messages.createCommentErrorTitle} />}
    description={
      <FormattedMessage {...messages.createCommentErrorDescriptionGeneric} />
    }
  />
);
